import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Game from "./components/Game";
import { createTetris } from "./tetris/Tetris";
import { localizations, getLanguage } from "./components/localization";

const tetris = createTetris();
let isGameOver = false;
tetris.onStateChange((state) => {
  isGameOver = state.isGameOver();
});
document.addEventListener("keydown", (event) => {
  const keyName = event.key;
  if (tetris.isRunning()) {
    if (keyName === "ArrowUp") {
      tetris.rotateCurrentPiece();
    } else if (keyName === "ArrowDown") {
      tetris.tick();
    } else if (keyName === "ArrowLeft") {
      tetris.moveLeft();
    } else if (keyName === "ArrowRight") {
      tetris.moveRight();
    } else if (keyName === " ") {
      tetris.pause();
    } else if (keyName === "Enter") {
      tetris.hardDrop();
    }
  } else {
    if (keyName === " " || (keyName === "Enter" && !isGameOver)) {
      if (tetris.isPaused()) {
        tetris.resume();
      } else {
        tetris.start();
      }
    } else if (keyName === "Enter" && isGameOver) {
      window.ysdk.features.GameplayAPI.stop();
      window.ysdk.adv.showFullscreenAdv({
        callbacks: {
          onClose: function (wasShown) {
            window.ysdk.features.GameplayAPI.start();
            tetris.start(true);
          },
          onError: function (error) {},
        },
      });
    }
  }
});

window.YaGames.init().then(function (ysdk) {
  window.ysdk = ysdk;
  window.addEventListener("focus", function (e) {
    window.ysdk.features.GameplayAPI.start();
    tetris.resume();
  });

  window.addEventListener("blur", function (e) {
    window.ysdk.features.GameplayAPI.stop();
    tetris.pause();
  });

  window.ysdk.features.LoadingAPI.ready();
  window.addEventListener("contextmenu", function (e) {
    e.preventDefault();
  });
  window.addEventListener("doubleclick", function (e) {
    e.preventDefault();
  });
  window.ysdk.features.GameplayAPI.stop();
  window.ysdk.adv.showFullscreenAdv({
    callbacks: {
      onClose: function (wasShown) {
        window.ysdk.features.GameplayAPI.start();
        document.querySelector("title").textContent =
          localizations.name[getLanguage()];
        ReactDOM.render(
          <React.StrictMode>
            <Game
              tetris={tetris}
              handleArrowLeft={() => tetris.isRunning() && tetris.moveLeft()}
              handleArrowRight={() => tetris.isRunning() && tetris.moveRight()}
              handleArrowRotate={() =>
                tetris.isRunning() && tetris.rotateCurrentPiece()
              }
              handleArrowBottom={() => tetris.isRunning() && tetris.tick()}
            />
          </React.StrictMode>,
          document.getElementById("root")
        );
        tetris.start();
      },
      onError: function (error) {},
    },
  });
});
